import axios, { AxiosError } from 'axios';
import { isNil } from 'lodash';

import useAuthStore from 'models/auth/auth.store';
import { getToken } from 'utils/localStorage';
import { BASE_URL } from 'config/api.config';
import { stopRefresh } from 'utils/refresh-token';

const axiosClient = axios.create();
axiosClient.defaults.baseURL = BASE_URL;

axiosClient.interceptors.request.use(
  (config) => {
    const accessToken = getToken();
    
    if (!isNil(accessToken) && !config.headers.Authorization && !config.headers.skipAuth) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  error => {
    return Promise.reject(new Error(error));
  }
);
axiosClient.interceptors.response.use(
  res => {
    return res;
  },
  async (err: AxiosError) => {
    const { isSignedIn } = useAuthStore.getState();

    // Access Token has expired
    if (err?.response?.status === 401 && isSignedIn) {
      useAuthStore.getState().logout();
      stopRefresh();
    }

    return Promise.reject(err);
  }
);



export default axiosClient;